var map = {
	"./symbol_0.png": "1a89",
	"./symbol_1.png": "d1e5",
	"./symbol_2.png": "22c7",
	"./symbol_3.png": "3efa",
	"./symbol_4.png": "bb64",
	"./symbol_5.png": "c01e",
	"./symbol_6.png": "1923",
	"./symbol_7.png": "1d8a",
	"./symbol_8.png": "3d94",
	"./symbol_9.png": "16fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5079";